module.exports = __webpack_public_path__ + "static/media/painel_KM.fad9e680.jpg";